/* global toastr */
import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import Swal from 'sweetalert2'
import { wrapView, request } from '../smart_bps/lib/utils'
import { stateToPropsSigur } from '../lib/stateToPropsSigur'
import { PROJECT_NAME } from './constants'
import { SigurModelView } from '../lib/SigurModelView'
import { Panel } from '../lib/components'
import AttrInput from '../smart_bps/lib/attr_input'
import AccessObjectTooltip from '../object_groups/AccessObjectTooltip'
import { initSelect2InModal, destroySelect2InModal } from '../lib/select2Modal'
import ApprovalProcessScheme from './ApprovalProcessScheme'
import { readTabQueryParam } from '../lib/docTabPersistence'

class ModelView extends SigurModelView {
  getDeleteConfirmTitle() {
    return 'Удаление заявки'
  }

  renderNotifications() {
    const notifications = this.state.notifications || []
    return notifications.map((notification, idx) => {
      const [alertType, text] = notification
      return (
        <div
          className={`alert ${alertType}`}
          key={`notification_${idx}`}
          dangerouslySetInnerHTML={{ __html: text }}
        />
      )
    })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    super.componentDidUpdate(prevProps, prevState, snapshot)

    if (
      prevState.approved !== this.state.approved
      || prevState.refusals !== this.state.refusals
    ) {
      this.syncDocTabFromLocation()
    }

    if (prevProps.router_params?.object_id !== this.props.router_params?.object_id) {
      this._peopleLoaded = false
      const newId = this.props.router_params?.object_id
      const isCreate =
        newId === 'new' || newId === undefined || parseInt(newId, 10) === 0
      this.resetCompositionState()
      if (!isCreate) {
        this.loadAccessObjects()
        this.loadObjectGroups()
        this.loadApprovals()
        this.loadApprovalScheme()
        this.loadApproved()
        this.loadRefusals()
      }
    }
    if (this.state.object_id && this.state.object_id !== 0 && !this._peopleLoaded) {
      this._peopleLoaded = true
      this.loadAccessObjects()
      this.loadObjectGroups()
      this.loadApprovals()
      this.loadApprovalScheme()
      this.loadApproved()
      this.loadRefusals()
    }
  }

  resetCompositionState() {
    this.setState({
      accessObjects: [],
      objectGroups: [],
      expandedGroupId: null,
      groupAccessObjects: {},
      approvals: [],
      approvalScheme: null,
      approved: [],
      refusals: [],
    })
  }

  constructor(props) {
    super(props)
    this.state = {
      ...this.state,
      // Посетители
      accessObjects: [],
      showAccessObjectsModal: false,
      modalAccessObjects: [],
      modalPage: 1,
      modalTotalPages: 1,
      modalSelectedIds: new Set(),
      modalExcludedIds: new Set(),
      modalFilters: {name: '', position: '', department: '', object_type: ''},
      isModalSelectedAll: false,
      filterOptions: {positions: [], departments: [], object_types: []},
      // Группы посетителей
      objectGroups: [],
      showObjectGroupsModal: false,
      modalObjectGroups: [],
      modalOGPage: 1,
      modalOGTotalPages: 1,
      modalOGSelectedIds: new Set(),
      modalOGExcludedIds: new Set(),
      isModalOGSelectedAll: false,
      modalOGFilters: {name: ''},
      expandedGroupId: null,
      groupAccessObjects: {},
      // Согласования по заявке
      approvals: [],
      // Схема процесса согласования (рисуется под активным согласованием)
      approvalScheme: null,
      // Соглсованы по заявке (вкладка «Результаты согласования»)
      approved: [],
      // Отказы по заявке (вкладка «Результаты согласования»)
      refusals: [],
      // История черного списка (в модалке заявки)
      showBlacklistHistoryForAoId: null,
      blacklistHistoryItems: [],
    }

    this.openBlacklistHistoryForAo = this.openBlacklistHistoryForAo.bind(this)
    this.closeBlacklistHistoryForAo = this.closeBlacklistHistoryForAo.bind(this)
    this.openAccessObjectsModal = this.openAccessObjectsModal.bind(this)
    this.closeAccessObjectsModal = this.closeAccessObjectsModal.bind(this)
    this.handleModalSearch = this.handleModalSearch.bind(this)
    this.handleSelectAllFound = this.handleSelectAllFound.bind(this)
    this.handleToggleAccessObject = this.handleToggleAccessObject.bind(this)
    this.handleApplyAccessObjects = this.handleApplyAccessObjects.bind(this)
    this.handleRemoveAccessObject = this.handleRemoveAccessObject.bind(this)
    this.loadAccessObjects = this.loadAccessObjects.bind(this)

    this.openObjectGroupsModal = this.openObjectGroupsModal.bind(this)
    this.closeObjectGroupsModal = this.closeObjectGroupsModal.bind(this)
    this.handleObjectGroupsModalSearch = this.handleObjectGroupsModalSearch.bind(this)
    this.handleObjectGroupsSelectAllFound = this.handleObjectGroupsSelectAllFound.bind(this)
    this.handleToggleObjectGroup = this.handleToggleObjectGroup.bind(this)
    this.handleApplyObjectGroups = this.handleApplyObjectGroups.bind(this)
    this.handleRemoveObjectGroup = this.handleRemoveObjectGroup.bind(this)
    this.loadObjectGroups = this.loadObjectGroups.bind(this)
    this.toggleGroupExpand = this.toggleGroupExpand.bind(this)
    this.loadGroupAccessObjects = this.loadGroupAccessObjects.bind(this)

    this.showTooltip = this.showTooltip.bind(this)
    this.hideTooltip = this.hideTooltip.bind(this)
    this.documentToState = this.documentToState.bind(this)
    this.accessObjectsModalRef = React.createRef()
    this.fileBlockRef = React.createRef()
  }

  openBlacklistHistoryForAo(accessObjectId) {
    this.setState({showBlacklistHistoryForAoId: accessObjectId, blacklistHistoryItems: null})
    const that = this
    request({
      method: 'get',
      url: `/api/access_objects/${accessObjectId}/blacklist_history`,
      success: (data) => {
        that.setState({blacklistHistoryItems: data.items || []})
      },
      error: () => {
        that.setState({blacklistHistoryItems: []})
        toastr.error('Не удалось загрузить историю')
      },
    })
  }

  closeBlacklistHistoryForAo() {
    this.setState({showBlacklistHistoryForAoId: null})
  }

  documentToState(data, cb) {
    const next = () => {
      if (typeof cb === 'function') cb()
      if (this.project_name === PROJECT_NAME && data.id && this.object_id === data.id) {
        this.loadApprovals()
        this.loadApprovalScheme()
        this.loadRefusals()
      }
    }
    super.documentToState(data, next)
  }

  hasPerm(perm) {
    return this.state.perms && this.state.perms.includes(perm)
  }

  copyRequestToNew() {
    const requestId = this.object_id
    if (!requestId || requestId === 0) {
      toastr.warning('Сначала сохраните заявку')
      return
    }
    Swal.fire({
      title: 'Скопировать данные в новую заявку?',
      text: 'Скопируются основные поля и файлы.',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Скопировать',
      cancelButtonText: 'Отмена',
      focusConfirm: false,
      focusCancel: false,
      customClass: {confirmButton: 'btn btn-outline-primary', cancelButton: 'btn btn-outline-secondary'},
      buttonsStyling: false,
    }).then((result) => {
      if (!result.isConfirmed) return
      request({
        method: 'post',
        url: `/api/${PROJECT_NAME}/${requestId}/copy_to_new`,
        success: (data) => {
          const newId = data && (data.id || data.request_id || data.document_id)
          if (!newId) {
            toastr.error('Не удалось определить ID новой заявки')
            return
          }
          toastr.success('Данные скопированы в новую заявку')
          this.setState({redirect_to: `/${PROJECT_NAME}/${newId}`})
        },
        error: (err) => toastr.error((err && err.detail) || 'Ошибка при копировании заявки'),
      })
    })
  }

  renderContentLeftActionRightItems() {
    const items = super.renderContentLeftActionRightItems()
    const roles = (this.props.user && this.props.user.roles) ? this.props.user.roles : []
    const canActions = Array.isArray(roles) && (roles.includes('applicant') || roles.includes('admin'))
    if (!canActions || !this.object_id || this.object_id === 0) return items

    const dropdown = (
        <div className="dropdown" key="actions_dropdown">
        <span
            className="btn btn-outline-primary waves-effect p-2 dropdown-toggle"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
        >
          Действия
        </span>
          <ul className="dropdown-menu dropdown-menu-start">
            <li>
              <a
                  className="dropdown-item"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault()
                    this.copyRequestToNew()
                  }}
              >
                Скопировать данные в новую заявку
              </a>
            </li>
          </ul>
        </div>
    )

    const editAllIdx = items.findIndex((x) => x && (x.key === 'edit_all' || x.key === 'exit_edit_all'))
    const insertIdx = editAllIdx >= 0 ? editAllIdx : items.length
    return [...items.slice(0, insertIdx), dropdown, ...items.slice(insertIdx)]
  }

  showTooltip(e, ao) {
    this.setState({
      tooltipData: ao,
      tooltipPosition: {top: e.clientY + 15, left: e.clientX - 100},
    })
  }

  hideTooltip() {
    this.setState({tooltipData: null})
  }

  loadApprovals() {
    const requestId = this.object_id
    if (!requestId || requestId === 0) return
    request({
      method: 'get',
      url: `/api/requests/${requestId}/approvals`,
      success: (data) => this.setState({approvals: data.items || []}),
      error: (data) => console.error('Error loading approvals:', data),
    })
  }

  loadApprovalScheme() {
    const requestId = this.object_id
    if (!requestId || requestId === 0) return
    request({
      method: 'get',
      url: `/api/requests/${requestId}/approval_scheme`,
      success: (data) => this.setState({approvalScheme: data || null}),
      error: (err) => {
        console.error('Error loading approval scheme:', err)
        this.setState({approvalScheme: null})
      },
    })
  }

  loadRefusals() {
    const requestId = this.object_id
    if (!requestId || requestId === 0) return
    request({
      method: 'get',
      url: `/api/requests/${requestId}/refusals`,
      success: (data) => this.setState({refusals: data.items || []}),
      error: () => this.setState({refusals: []}),
    })
  }

  loadApproved() {
    const requestId = this.object_id
    if (!requestId || requestId === 0) return
    request({
      method: 'get',
      url: `/api/requests/${requestId}/approved`,
      success: (data) => this.setState({approved: data.items || []}),
      error: () => this.setState({approved: []}),
    })
  }

  loadAccessObjects() {
    const requestId = this.object_id
    if (!requestId || requestId === 0) return
    request({
      method: 'get',
      url: `/api/requests/${requestId}/access_objects`,
      success: (data) => this.setState({accessObjects: data.items || []}),
      error: (data) => console.error('Error loading access objects:', data),
    })
  }

  loadModalAccessObjects(page = 1) {
    const requestId = this.object_id || 0
    const {modalFilters} = this.state
    request({
      method: 'post',
      url: `/api/requests/${requestId}/access_objects/list`,
      data: {page, page_size: 15, filters: modalFilters},
      success: (data) =>
          this.setState({
            modalAccessObjects: data.items || [],
            modalPage: data.page || 1,
            modalTotalPages: data.total_pages || 1,
            modelAlreadyAddedAOCnt: data.already_added_cnt || 0,
          }),
      error: (data) => console.error('Error loading modal access objects:', data),
    })
  }

  openAccessObjectsModal() {
    this.setState(
        {
          showAccessObjectsModal: true,
          modalSelectedIds: new Set(),
          modalFilters: {name: '', position: '', department: '', object_type: ''},
        },
        () => {
          this.loadModalAccessObjects(1)
          setTimeout(() => {
            initSelect2InModal(this.accessObjectsModalRef.current, (name, val) => {
              this.setState((prev) => ({
                modalFilters: {...prev.modalFilters, [name]: val},
              }))
            })
          }, 0)
        }
    )
  }

  closeAccessObjectsModal() {
    destroySelect2InModal(this.accessObjectsModalRef.current)
    this.setState({showAccessObjectsModal: false, isModalSelectedAll: false})
  }

  handleModalSearch() {
    this.loadModalAccessObjects(1)
    this.setState({isModalSelectedAll: false})
  }

  handleSelectAllFound(isCancelSelected) {
    this.setState({isModalSelectedAll: !isCancelSelected, modalExcludedIds: new Set(), modalSelectedIds: new Set()})
  }

  handleToggleAccessObject(aoId) {
    const {modalSelectedIds, modalExcludedIds, isModalSelectedAll} = this.state

    const newSelectedIds = isModalSelectedAll ? new Set(modalExcludedIds) : new Set(modalSelectedIds)
    if (newSelectedIds.has(aoId)) newSelectedIds.delete(aoId)
    else newSelectedIds.add(aoId)
    this.setState({
      [isModalSelectedAll ? 'modalExcludedIds' : 'modalSelectedIds']: newSelectedIds,
    })
  }

  handleApplyAccessObjects() {
    const {modalSelectedIds, modalExcludedIds, isModalSelectedAll, modalFilters} = this.state
    const requestId = this.object_id

    if (modalSelectedIds.size === 0 && !isModalSelectedAll) {
      toastr.warning('Не выбрано ни одного посетителя')
      return
    }
    if (!requestId || requestId === 0) {
      toastr.warning('Сначала сохраните заявку')
      return
    }
    request({
      method: 'post',
      url: `/api/requests/${requestId}/access_objects/add`,
      data: {
        is_selected_all: isModalSelectedAll,
        access_object_ids: Array.from(isModalSelectedAll ? modalExcludedIds : modalSelectedIds),
        filters: modalFilters,
      },
      success: () => {
        toastr.success('Посетители добавлены')
        this.closeAccessObjectsModal()
        this.loadAccessObjects()
      },
      error: (data) => toastr.error(data.detail || 'Ошибка при добавлении посетителей'),
    })
  }

  handleRemoveAccessObject(aoId) {
    const requestId = this.object_id
    Swal.fire({
      title: 'Удалить посетителя?',
      text: 'Посетитель будет удален из заявки',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Удалить',
      cancelButtonText: 'Отмена',
      focusConfirm: false,
      focusCancel: false,
      customClass: {confirmButton: 'btn btn-outline-primary', cancelButton: 'btn btn-outline-secondary'},
      buttonsStyling: false,
    }).then((result) => {
      if (result.isConfirmed) {
        request({
          method: 'post',
          url: `/api/requests/${requestId}/access_objects/remove`,
          data: {access_object_id: aoId},
          success: () => {
            toastr.success('Посетитель удален')
            this.loadAccessObjects()
          },
          error: (data) => toastr.error(data.detail || 'Ошибка при удалении посетителя'),
        })
      }
    })
  }

  // --- Группы посетителей ---

  loadObjectGroups() {
    const requestId = this.object_id
    if (!requestId || requestId === 0) return
    request({
      method: 'get',
      url: `/api/requests/${requestId}/object_groups`,
      success: (data) => this.setState({objectGroups: data.items || []}),
      error: (data) => console.error('Error loading object groups:', data),
    })
  }

  loadModalObjectGroups(page = 1) {
    const requestId = this.object_id || 0
    const {modalOGFilters} = this.state
    request({
      method: 'post',
      url: `/api/requests/${requestId}/object_groups/list`,
      data: {page, page_size: 15, filters: modalOGFilters},
      success: (data) =>
          this.setState({
            modalObjectGroups: data.items || [],
            modalOGPage: data.page || 1,
            modalOGTotalPages: data.total_pages || 1,
          }),
      error: (data) => console.error('Error loading modal object groups:', data),
    })
  }

  openObjectGroupsModal() {
    this.setState(
        {
          showObjectGroupsModal: true,
          modalOGSelectedIds: new Set(),
          modalOGFilters: {name: ''},
        },
        () => this.loadModalObjectGroups(1)
    )
  }

  closeObjectGroupsModal() {
    this.setState({showObjectGroupsModal: false})
  }

  handleObjectGroupsModalSearch() {
    this.loadModalObjectGroups(1)
    this.setState({isModalOGSelectedAll: false})
  }

  handleObjectGroupsSelectAllFound() {
    this.setState({isModalOGSelectedAll: true, modalOGExcludedIds: new Set()})
  }

  handleToggleObjectGroup(ogId) {
    const {modalOGSelectedIds, modalOGExcludedIds, isModalOGSelectedAll} = this.state
    const newSelectedIds = isModalOGSelectedAll ? new Set(modalOGExcludedIds) : new Set(modalOGSelectedIds)
    if (newSelectedIds.has(ogId)) newSelectedIds.delete(ogId)
    else newSelectedIds.add(ogId)
    this.setState({
      [isModalOGSelectedAll ? 'modalOGExcludedIds' : 'modalOGSelectedIds']: newSelectedIds,
    })
  }

  handleApplyObjectGroups() {
    const {modalOGSelectedIds, modalOGExcludedIds, isModalOGSelectedAll, modalOGFilters} = this.state
    const requestId = this.object_id
    if (modalOGSelectedIds.size === 0 && !isModalOGSelectedAll) {
      toastr.warning('Не выбрано ни одной группы посетителей')
      return
    }
    if (!requestId || requestId === 0) {
      toastr.warning('Сначала сохраните заявку')
      return
    }
    request({
      method: 'post',
      url: `/api/requests/${requestId}/object_groups/add`,
      data: {
        is_selected_all: isModalOGSelectedAll,
        object_group_ids: Array.from(isModalOGSelectedAll ? modalOGExcludedIds : modalOGSelectedIds),
        filters: modalOGFilters,
      },
      success: (data) => {
        const removed = Number(data?.removed_access_objects_count || 0)
        if (removed > 0) {
          toastr.success(`Группы добавлены. Убрано из выбранных объектов: ${removed}`)
        } else {
          toastr.success('Группы посетителей добавлены')
        }
        this.closeObjectGroupsModal()
        this.loadAccessObjects()
        this.loadObjectGroups()
      },
      error: (data) => toastr.error(data.detail || 'Ошибка при добавлении групп'),
    })
  }

  handleRemoveObjectGroup(objectGroupId) {
    const requestId = this.object_id
    Swal.fire({
      title: 'Удалить группу посетителей?',
      text: 'Группа будет удалена из заявки',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Удалить',
      cancelButtonText: 'Отмена',
      focusConfirm: false,
      focusCancel: false,
      customClass: {confirmButton: 'btn btn-outline-primary', cancelButton: 'btn btn-outline-secondary'},
      buttonsStyling: false,
    }).then((result) => {
      if (result.isConfirmed) {
        request({
          method: 'post',
          url: `/api/requests/${requestId}/object_groups/remove`,
          data: {object_group_id: objectGroupId},
          success: () => {
            toastr.success('Группа удалена')
            this.loadObjectGroups()
            this.setState((s) => {
              const goa = {...s.groupAccessObjects}
              delete goa[objectGroupId]
              return {
                expandedGroupId: s.expandedGroupId === objectGroupId ? null : s.expandedGroupId,
                groupAccessObjects: goa
              }
            })
          },
          error: (data) => toastr.error(data.detail || 'Ошибка при удалении группы'),
        })
      }
    })
  }

  toggleGroupExpand(groupId) {
    const {expandedGroupId, groupAccessObjects} = this.state
    if (expandedGroupId === groupId) {
      this.setState({expandedGroupId: null})
      return
    }
    this.setState({expandedGroupId: groupId}, () => {
      if (!groupAccessObjects[groupId]) this.loadGroupAccessObjects(groupId)
    })
  }

  loadGroupAccessObjects(groupId) {
    const requestId = this.object_id
    if (!requestId || requestId === 0) return
    request({
      method: 'get',
      url: `/api/requests/${requestId}/object_groups/${groupId}/access_objects`,
      success: (data) => {
        this.setState((s) => ({
          groupAccessObjects: {...s.groupAccessObjects, [groupId]: data.items || []},
        }))
      },
      error: (data) => {
        console.error('Error loading group access objects:', data)
        this.setState((s) => ({
          groupAccessObjects: {...s.groupAccessObjects, [groupId]: []},
        }))
      },
    })
  }

  // Скрываем поле-заглушку группы «Люди» — рендерим только кастомные таблицы
  renderFormAttr(attr, horizontal) {
    if (attr.name === 'people_section_placeholder' || attr.name === 'refusals_section_placeholder') return null
    if (attr.name === 'to_user_id') {
      const form_access = this.state.form_access || {}
      const data = this.state.form_data || {}
      const attr_error = this.state.form_errors && this.state.form_errors[attr.name]
      const attr_message = this.state.form_messages && this.state.form_messages[attr.name]
      return (
          <AttrInput
              key={attr.name}
              data_type={attr.data_type}
              widget={attr.widget}
              choice_name={attr.choice_name}
              choice_context={{contractor_empty: true}}
              choices={this.props.choices}
              name={attr.name}
              title={attr.title}
              value={data[attr.name]}
              access={this.state.edit_all_mode ? 'edit' : form_access[attr.name]}
              message={attr_message}
              error={attr_error}
              inner_attrs={attr.inner_attrs}
              horizontal={horizontal || false}
              tags={false}
              onChange={this.formChange}
          />
      )
    }
    return super.renderFormAttr(attr, horizontal)
  }

  // --- Основная информация и правая колонка ---

  renderInfo() {
    const state = this.state.state || 'draft'
    const authorId = this.state.author_id
    const responsibleId = this.state.responsible_id
    const stateTitle = this.getChoice(`bps_${PROJECT_NAME}_state`, state) || state
    const authorName = this.getChoice('User', authorId) || '---'
    const responsibleName = this.getChoice('User', responsibleId) || '---'
    return (
        <Panel header="Основная информация" key="info_panel">
          <div className="card-text">
            <div className="mb-2">
              <strong>Автор:</strong> {authorName}
            </div>
            <div className="mb-2">
              <strong>Ответственный:</strong> {responsibleName}
            </div>
            <div>
              <strong>Этап:</strong> {stateTitle}
            </div>
          </div>
        </Panel>
    )
  }

  renderApprovalsBlock() {
    const {approvals, approvalScheme} = this.state
    const roles = (this.props.user && this.props.user.roles) ? this.props.user.roles : []
    const isApplicantOrCaseOwner = roles.includes("case_owner") || roles.includes("applicant")
    const isAdmin = roles.includes("admin")
    const applicantSchemeOnly =
        isApplicantOrCaseOwner &&
        !isAdmin &&
        approvalScheme &&
        approvalScheme.approval_flow_status != null

    return (
        <Panel header="Согласования" key="approvals_panel">
          {approvals.length === 0 ? (
              <div className="text-center py-3 text-muted">
                <i className="ti ti-clipboard-off ti-lg d-block mb-2 opacity-75" aria-hidden/>
                <span className="small">Нет согласований по данной заявке</span>
              </div>
          ) : (
              <>
              {applicantSchemeOnly ? (
                  <ApprovalProcessScheme
                      scheme={approvalScheme}
                      getChoice={(choiceName, val) => this.getChoice(choiceName, val)}
                  />
              ) : (
              <div className="table-responsive table-responsive--approval-scheme">
                <table className="table table-sm table-hover mb-0">
                  <thead>
                  {(isAdmin || !isApplicantOrCaseOwner) && (
                      <tr>
                        <th style={{width: '1%'}}>№</th>
                        <th>Этап</th>
                        <th style={{width: '1%'}} className="text-end"/>
                      </tr>
                  )}
                  </thead>
                  <tbody>
                  {approvals.map((a) => {
                    const stateTitle = this.getChoice('bps_approvals_state', a.state) || a.state
                    const showSchemeForThisApproval =
                        approvalScheme &&
                        approvalScheme.approval_flow_status != null &&
                        Number(approvalScheme.approval_id) === Number(a.id)

                    return (
                        <React.Fragment key={a.id}>
                          {(isAdmin || !isApplicantOrCaseOwner) && (
                              <tr>
                                <td>
                                  <Link to={`/approvals/${a.id}/`}
                                        className="fw-medium text-decoration-none">{a.id}</Link>
                                </td>
                                <td>
                                  {stateTitle ? (
                                      <span className="badge bg-label-secondary">{stateTitle}</span>
                                  ) : (
                                      <span className="text-muted">—</span>
                                  )}
                                </td>
                                <td className="text-end">
                                  <Link
                                      to={`/approvals/${a.id}/`}
                                      className="btn btn-sm btn-outline-primary btn-icon"
                                      title="Открыть"
                                  >
                                    <i className="ti ti-arrow-right" aria-hidden/>
                                  </Link>
                                </td>
                              </tr>
                          )}
                          {showSchemeForThisApproval && !applicantSchemeOnly ? (
                              <tr>
                                <td colSpan={3}>
                                  <ApprovalProcessScheme
                                      scheme={approvalScheme}
                                      getChoice={(choiceName, val) => this.getChoice(choiceName, val)}
                                  />
                                </td>
                              </tr>
                          ) : null}
                        </React.Fragment>
                    )
                  })}
                  </tbody>
                </table>
              </div>
              )}
              </>
          )}
        </Panel>
    )
  }

  renderContentRight() {
    if (this.object_id === 0) return []
    const state = this.state.state || 'draft'
    const blocks = [this.renderInfo()]

    const filesSchema = this.state.files_schema || []
    if (filesSchema.length > 0) {
      blocks.push(
          this.renderFileBlock(true)
      )
    }

    if (state !== 'draft') {
      blocks.push(this.renderApprovalsBlock())
    }

    blocks.push(this.renderComments())
    return blocks
  }

  // --- Блок «Посетители» (кнопка: +Добавить посетителей) ---

  renderAccessObjectsTable() {
    const {accessObjects} = this.state
    const canAdd = this.hasPerm('add_access_objects')
    const canRemove = this.hasPerm('remove_access_objects')
    return (
        <Panel header="Посетители" key="access_objects_table">
          {canAdd && (
              <div className="mb-3">
                <button className="btn btn-primary btn-sm" onClick={this.openAccessObjectsModal}>
                  Добавить посетителей
                </button>
              </div>
          )}
          <div className="table-responsive">
            <table className="table table-sm">
              <thead>
              <tr>
                <th>ФИО</th>
                <th>Должность</th>
                <th>В черном списке</th>
                <th>Пройден мед. осмотр</th>
                {canRemove && <th style={{width: '50px'}}></th>}
              </tr>
              </thead>
              <tbody>
              {accessObjects.length === 0 ? (
                  <tr>
                    <td colSpan={canRemove ? 7 : 6} className="text-center text-muted">
                      Нет связанных посетителей
                    </td>
                  </tr>
              ) : (
                  accessObjects.map((ao) => (
                      <tr key={ao.id}>
                        <td><Link to={`/access_objects/${ao.access_object_id}/`} target="_blank">{ao.name}</Link></td>
                        <td>{ao.position}</td>
                        <td>
                          {ao.blacklist ? (
                              <span
                                  role="button"
                                  tabIndex={0}
                                  className="sigur-cell-link"
                                  onClick={() => this.openBlacklistHistoryForAo(ao.access_object_id)}
                                  onKeyDown={(e) => e.key === 'Enter' && this.openBlacklistHistoryForAo(ao.access_object_id)}
                              >
                          Да
                        </span>
                          ) : (
                              'Нет'
                          )}
                        </td>
                        <td>{ao.medical_exam}</td>
                        {canRemove && (
                            <td>
                              <button
                                  className="btn btn-outline-danger btn-xs"
                                  onClick={() => this.handleRemoveAccessObject(ao.access_object_id)}
                                  title="Удалить"
                              >
                                <i className="ti ti-trash"></i>
                              </button>
                            </td>
                        )}
                      </tr>
                  ))
              )}
              </tbody>
            </table>
            {this.renderBlacklistHistoryModalForRequest()}
          </div>
        </Panel>
    )
  }

  renderAccessObjectsModal() {
    const {
      showAccessObjectsModal,
      modalAccessObjects,
      modalPage,
      modalTotalPages,
      modalSelectedIds,
      modalFilters,
      filterOptions,
      isModalSelectedAll,
      modalExcludedIds,
      modelAlreadyAddedAOCnt
    } = this.state

    const isCancelSelected = (
      (isModalSelectedAll && !Array.from(modalExcludedIds).length)
      || (Array.from(modalSelectedIds).length === Array.from(modalAccessObjects).length - modelAlreadyAddedAOCnt)
    )

    if (!showAccessObjectsModal) return null
    return (
        <div
            ref={this.accessObjectsModalRef}
            className="modal fade show"
            style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.5)'}}
            key="access_objects_modal"
        >
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Доступные посетители</h5>
                <button type="button" className="btn-close" onClick={this.closeAccessObjectsModal}></button>
              </div>
              <div className="modal-body">
                <div className="card mb-3">
                  <div className="card-body">
                    <div className="row g-2 align-items-end access-objects-modal-filters">
                      <div className="col-md-3">
                        <label className="form-label">ФИО</label>
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            value={modalFilters.name}
                            onChange={(e) =>
                                this.setState({modalFilters: {...modalFilters, name: e.target.value}})
                            }
                            placeholder="Введите ФИО..."
                        />
                      </div>
                      <div className="col-md-3">
                        <label className="form-label">Должность</label>
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            value={modalFilters.position}
                            onChange={(e) =>
                                this.setState({
                                  modalFilters: {...modalFilters, position: e.target.value},
                                })
                            }
                            placeholder="Введите должность..."
                        />
                      </div>
                      <div className="col-md-12 mt-2">
                        <button className="btn btn-primary btn-sm me-2" onClick={this.handleModalSearch}>
                          Найти
                        </button>
                        <button className="btn btn-secondary btn-sm" onClick={() => this.handleSelectAllFound(isCancelSelected)}>
                          {isCancelSelected ? 'Отменить выбор' : 'Выбрать все найденные'}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="table-responsive">
                  <table className="table table-sm table-hover">
                    <thead>
                    <tr>
                      <th style={{width: '40px'}}></th>
                      <th>ФИО</th>
                      <th>Должность</th>
                      <th>В черном списке</th>
                      <th>Пройден мед. осмотр</th>
                      <th>Добавлен в группу</th>
                      <th style={{width: '40px'}}></th>
                    </tr>
                    </thead>
                    <tbody>
                    {modalAccessObjects.map((ao) => (
                        <tr key={ao.id} className={ao.already_added ? 'table-secondary' : ''}>
                          <td>
                            <input
                                type="checkbox"
                                className="form-check-input"
                                checked={
                                    modalSelectedIds.has(ao.id)
                                    || ao.already_added
                                    || isModalSelectedAll && !modalExcludedIds.has(ao.id)
                                }
                                disabled={ao.already_added}
                                onChange={() => this.handleToggleAccessObject(ao.id)}
                            />
                          </td>
                          <td><Link to={`/access_objects/${ao.id}/`} target="_blank">{ao.name}</Link></td>
                          <td>{ao.position}</td>
                          <td>
                            {ao.blacklist ? (
                                <span
                                    role="button"
                                    tabIndex={0}
                                    className="sigur-cell-link"
                                    onClick={() => this.openBlacklistHistoryForAo(ao.id)}
                                    onKeyDown={(e) => e.key === 'Enter' && this.openBlacklistHistoryForAo(ao.id)}
                                >
                              Да
                            </span>
                            ) : (
                                'Нет'
                            )}
                          </td>
                          <td>{ao.medical_exam}</td>
                          <td>
                            {ao.group_names && ao.group_names.length > 0
                                ? ao.group_names.join(', ')
                                : '—'}
                          </td>
                          <td>
                          <span
                              className="tooltip-link"
                              onMouseEnter={(e) => this.showTooltip(e, ao)}
                              onMouseLeave={this.hideTooltip}
                          >
                            <i className="ti ti-info-circle"></i>
                          </span>
                          </td>
                        </tr>
                    ))}
                    </tbody>
                  </table>
                </div>
                {modalTotalPages > 1 && (
                    <nav className="mt-3">
                      <ul className="pagination pagination-sm justify-content-center">
                        <li className={`page-item ${modalPage === 1 ? 'disabled' : ''}`}>
                          <a
                              className="page-link"
                              href="#"
                              onClick={(e) => {
                                e.preventDefault()
                                if (modalPage > 1) this.loadModalAccessObjects(modalPage - 1)
                              }}
                          >
                            Назад
                          </a>
                        </li>
                        {[...Array(modalTotalPages)].map((_, idx) => (
                            <li key={idx} className={`page-item ${modalPage === idx + 1 ? 'active' : ''}`}>
                              <a
                                  className="page-link"
                                  href="#"
                                  onClick={(e) => {
                                    e.preventDefault()
                                    this.loadModalAccessObjects(idx + 1)
                                  }}
                              >
                                {idx + 1}
                              </a>
                            </li>
                        ))}
                        <li className={`page-item ${modalPage === modalTotalPages ? 'disabled' : ''}`}>
                          <a
                              className="page-link"
                              href="#"
                              onClick={(e) => {
                                e.preventDefault()
                                if (modalPage < modalTotalPages) this.loadModalAccessObjects(modalPage + 1)
                              }}
                          >
                            Вперед
                          </a>
                        </li>
                      </ul>
                    </nav>
                )}
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={this.closeAccessObjectsModal}>
                  Отмена
                </button>
                <button type="button" className="btn btn-primary" onClick={this.handleApplyAccessObjects}>
                  Применить
                </button>
              </div>
            </div>
          </div>
          <AccessObjectTooltip data={this.state.tooltipData} position={this.state.tooltipPosition}/>
          {this.renderBlacklistHistoryModalForRequest()}
        </div>
    )
  }

  collectDocTabs() {
    const tabs = []
    let first_tab
    const form_schema = this.getFormSchema()

    form_schema.forEach((item) => {
      const tabTitle = item[0]
      if (first_tab === undefined) first_tab = tabTitle
      if (
        !tabs.includes(tabTitle)
        && (tabTitle !== 'Результаты согласования' || this.state.approved?.length || this.state.refusals?.length)
      ) {
        tabs.push(tabTitle)
      }
    })
    return { tabs, first_tab }
  }

  getDocTabPreferTab(tabs) {
    if (readTabQueryParam('from') === 'complete_approval' && tabs.includes('Результаты согласования')) {
      return 'Результаты согласования'
    }
    return null
  }

  renderBlacklistHistoryModalForRequest() {
    if (!this.state.showBlacklistHistoryForAoId) return null
    const items = this.state.blacklistHistoryItems || []
    const formatDate = (iso) => {
      if (!iso) return '—'
      try {
        const d = new Date(iso)
        return d.toLocaleString('ru-RU', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        })
      } catch (e) {
        return iso
      }
    }

    return (
      <div className="modal show d-block" tabIndex="-1" style={{background: 'rgba(0,0,0,0.5)'}}>
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">История изменений (черный список)</h5>
              <button type="button" className="btn-close" onClick={this.closeBlacklistHistoryForAo}
                      aria-label="Закрыть"/>
            </div>
            <div className="modal-body">
              <table className="table table-sm">
                <thead>
                <tr>
                  <th>В черном списке</th>
                  <th>Дата события</th>
                  <th>Причина</th>
                </tr>
                </thead>
                <tbody>
                {items.length === 0 && (
                    <tr>
                      <td colSpan={3} className="text-muted">Нет записей</td>
                    </tr>
                )}
                {items.map((row, idx) => (
                    <tr key={idx}>
                      <td>{row.in_blacklist_display || (row.in_blacklist ? 'Да' : 'Нет')}</td>
                      <td>{formatDate(row.d_event)}</td>
                      <td>{row.reason || '—'}</td>
                    </tr>
                ))}
                </tbody>
              </table>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={this.closeBlacklistHistoryForAo}>Закрыть
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  // Блок "Согласованы по заявке"
  approvedByRequestsRender() {
    const approved = this.state.approved || []
    if (!approved.length) return null
    return (
      <Panel header="Согласованы по заявке" key="approved_by_requests_table">
        <div className="table-responsive">
          <table className="table table-sm">
            <thead>
              <tr>
                <th>ФИО</th>
                <th>Доступы посетителя</th>
              </tr>
            </thead>
            <tbody>
              {this.state.approved.map((ga) => (
                <React.Fragment key={ga.granted_access_id}>
                  <tr>
                    <td><Link to={`/access_objects/${ga.ao_id}/`} target="_blank">{ga.ao_name}</Link></td>
                    <td><Link to={`/granted_accesses/${ga.granted_access_id}/`} target="_blank">Перейти</Link></td>
                  </tr>
                </React.Fragment>
                  ),
              )}
            </tbody>
          </table>
        </div>
      </Panel>
    )
  }

  refusalByRequestRender() {
    const refusals = this.state.refusals || []
      if (refusals.length === 0) return null
      return (
        <Panel header="Отказы по заявке" key="request_refusals_table">
          <div className="table-responsive">
            <table className="table table-sm">
              <thead>
                <tr>
                  <th>ФИО</th>
                  <th>Уровень согласования</th>
                  <th>Причина отказа</th>
                </tr>
              </thead>
              <tbody>
                {refusals.map((row) => (
                  <tr key={row.id}>
                    <td><Link to={`/access_objects/${row.ao_id}/`} target="_blank">{row.full_name}</Link></td>
                    <td>{row.approval_level || '---'}</td>
                    <td>{row.refusal_reason || '---'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Panel>
      )
  }

  // --- Блок «Группы посетителей» (таблица с раскрытием, удаление только admin) ---

  renderObjectGroupsTable() {
    const { objectGroups, expandedGroupId, groupAccessObjects } = this.state
    const canAdd = this.hasPerm('add_object_groups')
    const canRemove = this.hasPerm('remove_object_groups')

    return (
      <Panel header="Группы посетителей" key="object_groups_table">
        {canAdd && (
          <div className="mb-3">
            <button className="btn btn-primary btn-sm" onClick={this.openObjectGroupsModal}>
              Добавить группу посетителей
            </button>
          </div>
        )}
        <div className="table-responsive">
          <table className="table table-sm">
            <thead>
              <tr>
                <th style={{ width: '40px' }}></th>
                <th>Наименование</th>
                <th>Количество посетителей в группе</th>
                {canRemove && <th style={{ width: '50px' }}></th>}
              </tr>
            </thead>
            <tbody>
              {objectGroups.length === 0 ? (
                <tr>
                  <td colSpan={canRemove ? 4 : 3} className="text-center text-muted">
                    Нет групп посетителей
                  </td>
                </tr>
              ) : (
                objectGroups.map((og) => (
                  <React.Fragment key={og.id}>
                    <tr>
                      <td>
                        <button
                          type="button"
                          className="btn btn-link btn-sm p-0 text-secondary"
                          onClick={() => this.toggleGroupExpand(og.object_group_id)}
                          aria-expanded={expandedGroupId === og.object_group_id}
                        >
                          <i
                            className={`ti ti-chevron-${expandedGroupId === og.object_group_id ? 'down' : 'right'}`}
                          />
                        </button>
                      </td>
                      <td><Link to={`/object_groups/${og.object_group_id}/`} target="_blank">{og.name}</Link></td>
                      <td>{og.access_objects_count}</td>
                      {canRemove && (
                        <td>
                          <button
                            className="btn btn-outline-danger btn-xs"
                            onClick={() => this.handleRemoveObjectGroup(og.object_group_id)}
                            title="Удалить"
                          >
                            <i className="ti ti-trash"></i>
                          </button>
                        </td>
                      )}
                    </tr>
                    {expandedGroupId === og.object_group_id && (
                      <tr>
                        <td colSpan={canRemove ? 4 : 3} className="p-0 bg-light">
                          <div className="p-2">
                            <table className="table table-sm table-bordered mb-0">
                              <thead>
                                <tr>
                                  <th>ФИО</th>
                                  <th>Должность</th>
                                  <th>В черном списке</th>
                                  <th>Пройден мед. осмотр</th>
                                </tr>
                              </thead>
                              <tbody>
                                {(groupAccessObjects[og.object_group_id] || []).length === 0 ? (
                                  <tr>
                                    <td colSpan={5} className="text-center text-muted">
                                      Загрузка...
                                    </td>
                                  </tr>
                                ) : (
                                  (groupAccessObjects[og.object_group_id] || []).map((ao) => (
                                    <tr key={ao.access_object_id}>
                                      <td><Link to={`/access_objects/${ao.access_object_id}/`} target="_blank">{ao.name}</Link></td>
                                      <td>{ao.position}</td>
                                      <td>
                                        {ao.blacklist ? (
                                          <span
                                            role="button"
                                            tabIndex={0}
                                            className="sigur-cell-link"
                                            onClick={() => this.openBlacklistHistoryForAo(ao.access_object_id)}
                                            onKeyDown={(e) => e.key === 'Enter' && this.openBlacklistHistoryForAo(ao.access_object_id)}
                                          >
                                          Да
                                        </span>
                                        ) : (
                                          'Нет'
                                        )}
                                      </td>
                                      <td>{ao.medical_exam}</td>
                                    </tr>
                                  ))
                                )}
                              </tbody>
                            </table>
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))
              )}
            </tbody>
          </table>
        </div>
      </Panel>
    )
  }

  renderObjectGroupsModal() {
    const {
      showObjectGroupsModal,
      modalObjectGroups,
      modalOGPage,
      modalOGTotalPages,
      modalOGSelectedIds,
      modalOGFilters,
      modalOGExcludedIds,
      isModalOGSelectedAll
    } = this.state
    if (!showObjectGroupsModal) return null
    return (
      <div
        className="modal fade show"
        style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
        key="object_groups_modal"
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Доступные группы посетителей</h5>
              <button type="button" className="btn-close" onClick={this.closeObjectGroupsModal}></button>
            </div>
            <div className="modal-body">
              <div className="card mb-3">
                <div className="card-body">
                  <div className="row g-2 align-items-end">
                    <div className="col-md-6">
                      <label className="form-label">Наименование</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        value={modalOGFilters.name}
                        onChange={(e) =>
                          this.setState({ modalOGFilters: { ...modalOGFilters, name: e.target.value } })
                        }
                        placeholder="Введите наименование..."
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">ФИО посетителя</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        value={modalOGFilters.access_object_name}
                        onChange={(e) =>
                          this.setState({ modalOGFilters: { ...modalOGFilters, access_object_name: e.target.value } })
                        }
                        placeholder="Введите ФИО посетителя..."
                      />
                    </div>
                  </div>
                  <div className="col-md-6 d-flex align-items-end gap-2 mt-2"><button
                       className="btn btn-primary btn-sm px-2 py-1"
                       onClick={this.handleObjectGroupsModalSearch}
                     >
                       Найти
                     </button>
                     <button
                       className="btn btn-secondary btn-sm px-2 py-1"
                       onClick={this.handleObjectGroupsSelectAllFound}
                     >
                       Выбрать все найденные
                     </button>
                   </div>
                </div>
              </div>
              <div className="table-responsive">
                <table className="table table-sm table-hover">
                  <thead>
                    <tr>
                      <th style={{ width: '40px' }}></th>
                      <th>Наименование</th>
                      <th>Количество посетителей в группе</th>
                    </tr>
                  </thead>
                  <tbody>
                    {modalObjectGroups
                      .filter((og) => Number(og.access_objects_count ?? 0) > 0)
                      .map((og) => (
                        <tr key={og.id} className={og.already_added ? 'table-secondary' : ''}>
                          <td>
                            <input
                              type="checkbox"
                              className="form-check-input"
                              checked={
                                modalOGSelectedIds.has(og.id)
                                || og.already_added
                                || isModalOGSelectedAll && !modalOGExcludedIds.has(og.id)
                              }
                              disabled={og.already_added}
                              onChange={() => this.handleToggleObjectGroup(og.id)}
                            />
                          </td>
                          <td><Link to={`/object_groups/${og.id}/`} target="_blank">{og.name}</Link></td>
                          <td>{og.access_objects_count}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
              {modalOGTotalPages > 1 && (
                <nav className="mt-3">
                  <ul className="pagination pagination-sm justify-content-center">
                    <li className={`page-item ${modalOGPage === 1 ? 'disabled' : ''}`}>
                      <a
                        className="page-link"
                        href="#"
                        onClick={(e) => {
                          e.preventDefault()
                          if (modalOGPage > 1) this.loadModalObjectGroups(modalOGPage - 1)
                        }}
                      >
                        Назад
                      </a>
                    </li>
                    {[...Array(modalOGTotalPages)].map((_, idx) => (
                      <li key={idx} className={`page-item ${modalOGPage === idx + 1 ? 'active' : ''}`}>
                        <a
                          className="page-link"
                          href="#"
                          onClick={(e) => {
                            e.preventDefault()
                            this.loadModalObjectGroups(idx + 1)
                          }}
                        >
                          {idx + 1}
                        </a>
                      </li>
                    ))}
                    <li className={`page-item ${modalOGPage === modalOGTotalPages ? 'disabled' : ''}`}>
                      <a
                        className="page-link"
                        href="#"
                        onClick={(e) => {
                          e.preventDefault()
                          if (modalOGPage < modalOGTotalPages) this.loadModalObjectGroups(modalOGPage + 1)
                        }}
                      >
                        Вперед
                      </a>
                    </li>
                  </ul>
                </nav>
              )}
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={this.closeObjectGroupsModal}>
                Отмена
              </button>
              <button type="button" className="btn btn-primary" onClick={this.handleApplyObjectGroups}>
                Применить
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderFormGroupInclude(item, position) {
    const tabTitle = item[0]
    if (tabTitle === 'Состав заявки' && position === 'bottom') {
      return (
        <React.Fragment key="people_blocks">
          {this.renderAccessObjectsTable()}
          {this.renderObjectGroupsTable()}
        </React.Fragment>
      )
    }
    if (tabTitle === 'Результаты согласования' && position === 'bottom') {
      return (
        <React.Fragment key="decision_by_request_block">
          {this.approvedByRequestsRender()}
          {this.refusalByRequestRender()}
        </React.Fragment>
    )
    }
    return null
  }

  renderModals() {
    const modals = super.renderModals ? super.renderModals() : []
    return [...modals, this.renderAccessObjectsModal(), this.renderObjectGroupsModal()]
  }
}

export default wrapView(ModelView, (state) => {
  return stateToPropsSigur(state, PROJECT_NAME)
})
